import{useState as t,useEffect as r}from"react";var a=function(){var a=t(),i=a[0],n=a[1];return r((function(){n(window.matchMedia("(max-width: 768px)").matches)}),[]),i};export{a as IsMobile};
//# sourceMappingURL=is-mobile.js.map
